import Blue from '~/core';

// color setup
new Blue({
	name: 'Primary Color Selector',
	selector: '.theme-selector--primary',
	setup(root) {
		setupColorSelector();
	},
});

function setupColorSelector() {
  // const primaryColor = "#3498db";
  // const secondaryColor = "#2ecc71";


  const root = document.documentElement;

  // root.style.setProperty("--market-primary-theme-color", primaryColor);
  // root.style.setProperty("--market-secondary-theme-color", secondaryColor);
}
